export default __webpack_public_path__ + "static/media/acessibilidade-color.dceb9710.png";